module.exports = __webpack_public_path__ + "static/media/6521.c33cae5a.jpg";